module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-114x114.5f135c77cffeb43a5b18214654af4740.png";